// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__+lRPl","spinner":"Loader_spinner__iDFIv","spin":"Loader_spin__E4RJ0","srOnly":"Loader_srOnly__ePPJx"};